import { PackagePanelWebComponent } from './component/PackagePanelWebComponent';
import { WEB_COMPONENT_PACKAGE_PANEL } from '../../webcomponents.constants';

export { PackagePanelWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_PANEL, PackagePanelWebComponent);
